import { render } from "./AddPage.vue?vue&type=template&id=067e9370"
import script from "./AddPage.vue?vue&type=script&lang=js"
export * from "./AddPage.vue?vue&type=script&lang=js"

import "@/assets/vue-multiselect.min.css?vue&type=style&index=0&lang=css"
import "./AddPage.vue?vue&type=style&index=1&id=067e9370&lang=css"

import exportComponent from "/home/runner/work/corpsales-services/corpsales-services/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__